<template>
	<div>
		<div slot="header">{{ $t('Extra options response') }}</div>

		<tooltip label="option message" placement="right">
			<input
				type="text"
				:placeholder="$t('option message')"
				class="form-control"
				v-model.lazy="extra_options.message"
			/>
		</tooltip>

		<table class="table table-bordered table-striped table-sm">
			<thead>
				<tr>
					<th>{{ $t('Label') }}</th>
					<th>{{ $t('Value') }}</th>
					<th>{{ $t('action') }}</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(opt, index) in extra_options.options" :key="`extra-opts-${index}`">
					<td v-html="opt.label"></td>
					<td
						v-html="Object.values(fixed_commands).indexOf(opt.value) >= 0 ? $t(opt.value) : opt.value"
					></td>
					<td class="col d-inline-flex justify-content-center align-items-center">
						<span @click="edit_opt_mode(index)" :title="$t('edit')">
							<i class="fa fa-edit"></i>
						</span>
						&nbsp;
						<span @click="remove_opt(index)" :title="$t('delete')">
							<i class="fa fa-remove"></i>
						</span>
					</td>
				</tr>
				<tr v-if="!(extra_options.options || []).length">
					<td colspan="2">
						<div class="text-center">{{ $t('no data') }}</div>
					</td>
				</tr>
			</tbody>
		</table>
		<div>
			<tooltip label="Option Label" placement="right">
				<input
					type="text"
					:placeholder="$t('Option Label')"
					class="form-control"
					v-model="extra_opt.label"
					v-autocomplete="autocomplete"
				/>
			</tooltip>
			<tooltip label="option value" placement="right">
				<select
					name="resp_action_type"
					:class="{'form-control': true}"
					@change="(e) => extra_opt.value = e.target.value"
				>
					<option
						value
						:selected="!(Object.values(fixed_commands).indexOf(extra_opt.value) >= 0)"
					>{{ $t('custom text') }}</option>
					<option
						v-for="(command, index) in Object.values(fixed_commands)"
						:key="`fixed-command-${index}`"
						:value="command"
					>{{ $t(command) }}</option>
				</select>
			</tooltip>
			<tooltip
				label="option value text"
				placement="right"
				v-if="!(Object.values(fixed_commands).indexOf(extra_opt.value) >= 0)"
			>
				<input
					type="text"
					class="form-control"
					v-model="extra_opt.value"
					:placeholder="$t('option value text')"
					v-autocomplete="autocomplete"
				/>
			</tooltip>
			<div class>
				<button
					type="button"
					v-show="opt_mode == 'add'"
					@click="add_opt()"
					class="btn btn-primary btn-sm"
				>
					{{ $t('Add') }}
				</button>
				<button
					type="button"
					v-show="opt_mode == 'edit'"
					@click="edit_opt()"
					class="btn btn-primary btn-sm"
				>{{ $t('Edit') }}</button>
			</div>
		</div>

		<button @click="updateResponseData" class="btn btn-primary">
			Save
		</button>
	</div>
</template>

<script>
import axios from 'axios';
import Utilities from '@/directives/Autocomplete/Utilities';

export default {
	data() {
		return {
			extra_opt: {
				label: '',
				value: '',
			},
			active_opt_index: -1,
			extra_options:  {
				message: '',
				options: [],
			},
			autocomplete: {},
			fixed_commands: {},
			opt_mode: 'add'
		}
	},
	methods: {
		edit_opt() {
			if (this.active_opt_index >= 0 && this.extra_opt.label != '' && this.extra_opt.value != '') {
				for (var i = 0; i < this.extra_options.options.length; i++) {
					if (i == this.active_opt_index) {
						this.extra_options.options[i] = this.extra_opt
					}
				}
				this.active_opt_index = -1
				this.opt_mode = 'add'
				this.extra_opt = {
					label: '',
					value: '',
				}
			}
		},
		remove_opt(index) {
			var recs = []
			for (var i = 0; i < this.extra_options.options.length; i++) {
				if (i != index) {
					recs.push(this.extra_options.options[i])
				}
			}
			this.extra_options.options = recs
		},
		add_opt() {
			if (
				this.extra_opt.label != '' &&
				this.extra_opt.value != '' &&
				!this.check_exist_opt(this.extra_opt.label)
			) {
				this.extra_options.options.push(this.extra_opt)
				this.extra_opt = {
					label: '',
					value: '',
				}
			}
		},
		edit_opt_mode(index) {
			this.opt_mode = 'edit'
			this.active_opt_index = index
			this.extra_opt = this.extra_options.options[index]
			return true
		},
		check_exist_opt(label) {
			for (var i = 0; i < this.extra_options.options.length; i++) {
				if (this.extra_options.options[i].label == label) {
					return true
				}
			}
			return false
		},
		get_fixed_commands() {
			return new Promise((resolve, reject) => {
				axios
					.get('/command/get_fixed_commands')
					.then((res) => {
						if (res.data.status == 1 && is_obj(res.data.data)) {
							this.fixed_commands = res.data.data
						}
						resolve(res)
					})
					.catch((e) => {
						resolve(e)
					})
			})
		},
		updateResponseData() {
			this.$store.commit('setResponseDataProperty', {resp_api_extra_resp: this.extra_options})

			this.$router.push(`/services/${this.serviceId}/commands/${this.commandId}/result/fallback`)
		},
		async get_command_response() {
			const res = await axios.get(`/command_response/get/${this.commandId}`)

			if (res.data.status != 1) return

			var record = res.data.data

			if (!is_obj(record.resp_data_source_resp_struct)) {
				record.resp_data_source_resp_struct = {
					title_key: '',
					title_default_value: '',
					subtitle_key: '',
					subtitle_default_value: '',
					media_key: '',
					media_default_value: '',
					item_label_key: '',
					item_label_default_value: '',
					item_value_key: '',
					item_value_default_value: '',
					buttons: [
						{
							item_label_key: '',
							item_label_default_value: '',
							item_value_key: '',
							item_value_default_value: '',
						},
					],
				}
			}
			if (!is_arr(record.resp_static_cards_resp_struct)) {
				record.resp_static_cards_resp_struct = []
			}

			if (!is_arr(record.resp_location_resp_struct)) {
				record.resp_location_resp_struct = []
			}

			if (!record.resp_dataset) {
				record.resp_dataset = this.dataset
			}

			if (!is_arr(record.resp_data_source_resp_struct.buttons)) {
				record.resp_data_source_resp_struct.buttons = [
					{
						item_label_key: record.resp_data_source_resp_struct.item_label_key || '',
						item_label_default_value: record.resp_data_source_resp_struct.item_label_default_value || '',
						item_value_key: record.resp_data_source_resp_struct.item_value_key || '',
						item_value_default_value: record.resp_data_source_resp_struct.item_value_default_value || '',
					},
				]
			}

			if (!is_arr(record.resp_api_resp_struct.buttons)) {
				record.resp_api_resp_struct.buttons = [
					{
						item_label_key: record.resp_api_resp_struct.item_label_key || '',
						item_label_default_value: record.resp_api_resp_struct.item_label_default_value || '',
						item_value_key: record.resp_api_resp_struct.item_value_key || '',
						item_value_default_value: record.resp_api_resp_struct.item_value_default_value || '',
					},
				]
			}

			if (!is_arr(record.resp_dataset.resp.buttons)) {
				record.resp_dataset.resp.buttons = [
					{
						item_label_key: record.resp_dataset.resp.item_label || '',
						item_value_key: record.resp_dataset.resp.item_value || '',
					},
				]
			}

			if (record.resp_user_data_dataset_id) {
				this.generate_ds_schema(res.data.data.resp_user_data_dataset_id)
			}

			if (record.resp_api_resp_struct.receipt && record.resp_api_resp_struct.receipt.dataset_id) {
				this.generate_ds_schema(record.resp_api_resp_struct.receipt.dataset_id)
			} else if (record.resp_user_data_dataset_id) {
				this.generate_ds_schema(record.resp_user_data_dataset_id)
			}

			if (!is_obj(record.resp_api_extra_resp)) {
				var resp_opts_clone = clone(record.resp_api_extra_resp || [])
				record.resp_api_extra_resp = {
					message: '',
					options: resp_opts_clone,
				}
			}

			if (!is_arr(record.resp_menu_extra_options)) {
				record.resp_menu_extra_options = []
			}

			if (!is_arr(record.resp_quick_reply)) {
				record.resp_quick_reply = []
			}
			
			record.resp_dataset

			var data = this.buildCommandResult(record)

			record = Utilities.deepExtend(record, data, true)

			this.$store.commit('setResponseData', record);

			// this.setAutoCompeleteSchema()
		},
	},
	created() {
		this.get_fixed_commands();

		if (!this.$store.state.responseData) {
			this.get_command_response()
		}

		this.extra_options = this.$store.state.responseData.resp_api_extra_resp
	},
	computed: {
		serviceId() {
			return this.$route.params.service_id
		},
		commandId() {
			return this.$route.params.command_id
		},
	},
}
</script>
